/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum LinkEntityType {
  Compact = 'Compact',
  Project = 'Project',
  CompactIndicator = 'CompactIndicator',
}
